<template lang="pug">

    .map

        .map__title
            span(v-html='content.title')

        .map__container
            .map__group(ref='group')
                .map__wrap(v-for='(map, index) in maps', :class='{active: currentSlideIndex === index}')
                    .map__pic(v-html='map.map')
                    .map__lines(v-html='map.lines')
                    .map__text-box(v-if='content.textBox', :style='{width: content.textBox.width + "%"}')
                        .map__text(v-html='content.textBox.text.join("")')
                    .map__anchors
                        .map__anchor(
                            v-for='item in map.anchors',
                            :data-label-position='item.labelPosition',
                            :data-font-size='item["font-size"]',
                            :class='{strong: item.type === "kpp"}',
                            :style='{top: item.top + "%", left: item.left + "%"}')
                                svg.map__point.map__point--kpp(v-if='item.type === "kpp"', xmlns='http://www.w3.org/2000/svg', width='43', height='44', viewBox='0 0 43 44')
                                    path(d='M21.5 42.3C10.3 42.3 1.2 33.2 1.2 22S10.3 1.7 21.5 1.7c11.2 0 20.3 9.1 20.3 20.3v.3c-.2 11.1-9.2 20-20.3 20zm0-39.5C10.9 2.8 2.4 11.4 2.4 22a19.2 19.2 0 0 0 38.4.3C40.8 11.7 32.2 3 21.6 3h-.1v-.2z')
                                    path(d='M11.2 19.2h20.7v5.9H11.2v-5.9z')
                                svg.map__point.map__point--air(v-if='item.type === "air"', xmlns='http://www.w3.org/2000/svg', width='16.82', height='15.97', viewBox='0 0 16.82 15.97')
                                    path(d='M0 8a1.29 1.29 0 0 0 1.26 1.25h4.63l4.2 6.75h1.68l-2.1-6.75h4.62l1.26 1.68h1.27L16 8l.82-3h-1.27l-1.26 1.73H9.67L11.77 0h-1.68l-4.2 6.73H1.26A1.29 1.29 0 0 0 0 8z')
                                svg.map__point.map__point--anchor(v-if='item.type === "anchor"', width='21.02', height='25.26', viewBox='0 0 21.02 27.26')
                                    path(d='m18.88 19.43a3.63 3.63 0 0 1-1.7 3.9A5.07 5.07 0 0 1 16 24a14.39 14.39 0 0 0-5 3c-.38.36-.65.39-1 0a15.44 15.44 0 0 0-5-3 4.46 4.46 0 0 1-3.17-4.34 3.48 3.48 0 0 1 2.32.79 3.78 3.78 0 0 0 3.58 1 1.63 1.63 0 0 0 1.57-1.77c.05-2.75.1-5.51 0-8.26a3.93 3.93 0 0 0-3.48-3.81l-.54-.13V6.26c1.22-.44 2.87.54 3.6-.91h3.24c.73 1.41 2.33.54 3.64.88v1.25a7.93 7.93 0 0 0-1.38.33 3.87 3.87 0 0 0-2.65 3.52c-.09 2.75-.06 5.51 0 8.26a1.61 1.61 0 0 0 1.51 1.81 4.18 4.18 0 0 0 3.54-.86 13 13 0 0 1 2.1-1.11z')
                                    path(d='M21 18.6l-5.29.91 1.71-5.41zM0 18.6l3.58-4.5 1.7 5.42zM8.13 2.38A2.32 2.32 0 0 1 10.5 0a2.4 2.4 0 0 1 2.42 2.36 2.41 2.41 0 0 1-2.39 2.4 2.37 2.37 0 0 1-2.4-2.38zm2.41 1.43A1.46 1.46 0 0 0 12 2.37 1.48 1.48 0 0 0 10.52.94a1.51 1.51 0 0 0-1.47 1.5 1.49 1.49 0 0 0 1.49 1.37z')
                                span.map__point.map__point--point(v-if='item.type === "point" || item.type === "point-strong"')
                                .map__label(v-html='item.label', :class='{strong: item.type === "point-strong"}', :style='{top: item.shiftLabelTop + "px", left: item.shiftLabelLeft + "px"}')

            .map__toggle(v-if='content.toggle')
                .toggle__wrap
                    button.toggle__btn(v-for='(item, index) in content.toggle', @click='setCurrentMap(index)', :class='{current: currentSlideIndex === index}')
                        span(v-html='item.name')
                .toggle__wrap
                    .toggle__symbol(v-for='item in content.toggle', :style='{color: item.color}')
                        svg.toggle__symbol--kpp(v-if='item.type === "kpp"', xmlns='http://www.w3.org/2000/svg', width='20.2', height='20.2', viewBox='0 0 20.2 20.2', fill='#6cc5cd')
                            path(d='M10.1,20.2A10.1,10.1,0,1,1,20.2,10.1,10.07,10.07,0,0,1,10.1,20.2ZM10.1.6A9.56,9.56,0,0,0,.6,10.1a9.56,9.56,0,0,0,9.5,9.5,9.56,9.56,0,0,0,9.5-9.5A9.56,9.56,0,0,0,10.1.6Z')
                            rect(x="4.9" y="8.6" width="10.3" height="2.9")
                        span
                .toggle__wrap
                    .toggle__value(v-for='item in content.toggle', v-html='item.value', :style='{color: item.color}')

        .map__share(v-if="share")
            share(:url="share.shareUrl", :title="share.title", :description="share.description")

</template>

<script>
import Share from '@/components/Share.vue';
import {mapGetters} from 'vuex';

export default {
    name: 'Map',

    props: {
        content: {
            default: () => {
                return {};
            },
            type: Object
        },
        active: {
            default: false,
            type: Boolean
        },
        isLiteMode: {
            default: false,
            type: Boolean
        }
    },

    components: {
        Share
    },

    data() {
        return {
            currentSlideIndex: 0
        };
    },

    computed: {
        ...mapGetters('core', ['shareMap']),

        maps() {
            if (!this.content) return '';
            return this.content.maps || {};
        },

        text() {
            if (!this.content) return '';
            return this.content.text ? this.content.text.join('') : '' || '';
        },

        share() {
            return this.content.shareIndex ? this.shareMap[this.content.shareIndex] || null : null;
        }
    },

    mounted() {
        this.$refs.group.scrollTo({left: this.$refs.group.scrollWidth / 2 - window.innerWidth / 2});
    },

    beforeDestroy() {},

    methods: {
        setCurrentMap(index) {
            this.currentSlideIndex = index;
        }
    }
};
</script>

<style lang="scss">
//
@import '../assets/css/vars';
//
.map {
    position: relative;
    margin-bottom: var(--width-column-grid);

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        margin-bottom: 2rem;
    }

    &__title {
        display: block;
        text-align: center;
        color: var(--color-accent);
        font-family: var(--font-accent);
        margin: 0 auto var(--width-column-grid);

        span {
            padding: 0.5em;
            background-color: rgba(#01fff0, 0.15);
        }

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            margin-bottom: 2em;
            line-height: 2.2;

            span {
                padding: 0.2em;
                background-color: rgba(#01fff0, 0.15);
            }
        }
    }

    &__container {
        position: relative;
        width: 100%;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            // min-height: 100vh;
            display: flex;
            flex-direction: column-reverse;
            justify-content: flex-end;
        }
    }

    &__toggle {
        position: absolute;
        left: 4%;
        top: calc(var(--width-column-grid) * 0.5);
        display: flex;
        font-size: 0.7em;
        font-family: var(--font-accent);

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            left: 0;
            position: relative;
            flex-wrap: wrap;
            padding: var(--scr-padding-side);
        }
    }

    .toggle {
        &__wrap {
            display: flex;
            flex-direction: column;

            &:first-child {
                @media (--viewport-mobile), (--viewport-tablet-pt) {
                    width: 100%;
                    margin-bottom: 1em;
                }
            }
        }

        &__btn {
            padding: 0.2em 0;
            margin-right: 3em;
            text-align: left;
            color: var(--color-accent);
            opacity: 0.3;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                margin-bottom: 0.5em;
            }

            &.current,
            &:hover {
                opacity: 1;
            }

            &.current {
                span {
                    background-color: rgba(#01fff0, 0.3);
                }
            }
        }

        &__symbol {
            margin-left: auto;
            width: 8em;
            height: 1.9em;
            padding: 0.2em 0;
            vertical-align: middle;
            display: flex;
            align-items: center;
            margin-right: 1em;

            span {
                display: block;
                flex-grow: 1;
                flex-shrink: 0;
                width: 100%;
                border-bottom: dotted 1px currentColor;
            }

            &--kpp {
                height: 100%;
                width: 1.5em;
                flex-shrink: 0;
                margin-right: 0.4em;
            }
        }

        &__value {
            text-align: left;
            padding: 0.2em 0;
        }
    }

    &__group {
        position: relative;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            height: 100vh;
            overflow-x: auto;
        }
    }

    &__wrap {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: opacity 0.3s ease;

        &:first-child {
            position: relative;
        }

        &.active {
            opacity: 1;
            pointer-events: all;
        }

        &:not(.active) {
            opacity: 0;
            pointer-events: none;
        }

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            height: 100%;
            width: fit-content;
        }
    }

    &__pic,
    &__lines {
        height: 100%;
        width: 100%;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            width: fit-content;
        }

        svg {
            width: 100%;
            height: auto;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                height: 100%;
                width: auto;
            }
        }
    }

    &__lines {
        position: absolute;
        top: 0;
        left: 0;
    }

    &__anchors {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    &__anchor {
        position: absolute;
        color: var(--color-accent);
        font-family: var(--font-accent);
        font-size: 0.7em;
        display: flex;
        align-items: flex-end;

        &[data-label-position='top'] {
            flex-direction: column-reverse;
            align-items: flex-start;
        }

        &[data-label-position='bottom'] {
            flex-direction: column;
            align-items: flex-start;
        }

        &[data-font-size='small'] {
            font-size: 0.6em;
        }

        &[data-font-size='large'] {
            font-size: 0.9em;
        }
    }

    &__point {
        margin-right: 0.3em;

        &--anchor,
        &--air,
        &--kpp {
            fill: var(--color-accent);
            width: 1.5em;
            height: 1.5em;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                width: 1.5em;
                height: 1.5em;
            }
        }

        &--kpp {
            fill: var(--color-accent-strong);
        }

        &--point {
            width: 0.5em;
            height: 0.5em;
            box-shadow: 0 0 10px 2px var(--color-accent);
            border-radius: 100%;
            background-color: var(--color-accent);

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                width: 0.75em;
                height: 0.75em;
            }

            .map__anchor[data-font-size='large'] & {
                width: 0.7em;
                height: 0.7em;
            }

            .strong & {
                width: 0.7em;
                height: 0.7em;
                background-color: var(--color-accent-strong);
                box-shadow: 0 0 5px 1px var(--color-accent-strong);

                @media (--viewport-mobile), (--viewport-tablet-pt) {
                    width: 0.6em;
                    height: 0.6em;
                }
            }
        }
    }

    &__label {
        position: relative;

        .strong & {
            color: var(--color-accent-strong);
            font-size: 0.9em;
        }
    }

    &__text-box {
        position: absolute;
        bottom: 0;
        right: var(--width-column-grid);
        color: var(--color-accent);
        font-size: 0.9em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            right: 0;
            font-size: 0.7em;
        }
    }

    &__share {
        color: var(--color-header);
        display: flex;
        justify-content: center;
        padding-top: 1em;
    }
}
</style>
